export default {
	"order.TheProductYouPurchasedCannotBeActivatedTemporarilyYouCanLogInToTheCallAppToManuallyActivateItOrContactCustomerServiceForHelp": "您购买的商品当前暂时无法被激活，您可登录【叫叫】App中进行手动激活或联系客服提供帮助",
	"order.yourPurchases": "您购买的商品",
	"order.ItHasBeenActivatedPleaseEnterTheCallAppAsSoonAsPossibleToExperience": "已被激活，请尽快进入【叫叫】App中进行体验",
	"order.ParameterError": "参数错误!",
	"order.courseIsActive": "课程激活中",
	"order.youHavePurchased": "您已购买的",
	"order.Product": "商品"
}